import type { TagTypeResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetTagsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetTagsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, REFERENCE_DATA_STALE_TIME_MS } from 'src/utils';

export const useGetTags = createQueryHook<
  Record<string, never>,
  TagTypeResponseRow[],
  GetTagsQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.tag.allTypes.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ tag_type: data }),
  // Org reference data; writes invalidate it. See COI-882.
  trpcStaleTime: REFERENCE_DATA_STALE_TIME_MS,
  graphqlDocument: GetTagsDocument,
});
